(function() {
  'use strict';

  var close = false;
  var europe = ['AX','DK','EE','FO','FI','GG','IS','IE','JE','IM','LV','LT','NO','SJ','SE','GB','AL','AD','BA','HR','CY','GI','GR','IT','MK','VA','MT','ME','PT','SM','RS','SI','ES','BY','BG','CZ','GE','HU','MD','PL','RO','RU','SK','UA','AT','BE','FR','DE','LI','LU','MC','NL','CH'];

  /**
   * Retrieves the current users IP Address
   * @returns {Promise} resolves with the IP and other intel
   */
  function getIntel() {
    return fetch('https://geoip.conversio.com/json/', {
      method: 'GET'
    })
      .then(function(res) {
        return res.json();
      })
      .then(function(data) {
        return data;
      });
  }

  /**
   * Gets the cookie with the passed name
   * @param {String} name - the name of the cookie
   * @returns {String/Boolean/Number} the contents of the cookie
   */
  function getCookie(name) {
    var cookies = document.cookie.split('; ').reduce((p, c) => {
      var split = c.split(/=/);
      p[split[0]] = split[1];
      return p
    }, {});
    return cookies[name];
  }

  /**
   * Checks if there is a cookie and what it's content are
   * then checks whether the user has accepted or declined
   * and returns the result
   * @param {String} ip - the users current IP
   * @returns {Object} the has accepted result and ip
   */
  function checkCookie(ip) {
    var url = window.location.href;

    // First check if there is a cookie stored
    var acceptCookie = getCookie('_accept_banner');
    var ipCookie = getCookie('_accept_banner_ip');

    // They accepted the cookie previously
    if (acceptCookie) return { showBanner: false, ip: ip };

    // No accept in the cookie, continue
    return { showBanner: true, ip: ip };
  }

  /**
   * Logs the decision and IP to the server
   * @param {String} choice - 'accept' or 'decline'
   * @param {String} ip - the users current IP
   * @returns {Promise} resolves on successfully sent log
   
  function addLog(choice, ip) {
    var meta = {
      choice,
      notification: '5b051b43eb037900143b1346',
      ip: ip,
      userAgent: navigator.userAgent,
      url: window.location.href
    };

    return fetch('/log', {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(meta)
    })
    .catch(function(e) {
      console.error('An error occurred while trying to ' +
        'record the acceptance of cookies', e);
    });
  }

  /**
   * Adds the HTML elements with styles and event listeners
   * @param {String} ip - the users current IP
   */
  function addNotification(ip) {
    // Create the container of the notification
    var container = document.createElement('div');
    container.style.cssText = 'background:#00000080;position:fixed;' +
      'left:0px;right:0px;transition: all 0.3s ease-in;' +
      'padding:0.5em 0.5em 0.5em;font-family:Arial, Helvetica, sans-serif;' +
      'z-index: 999';

    var description = document.createElement('div');
    description.style.cssText = 'color:#FFFFFF; text-align: center';
    description.innerHTML = '<p style="margin-bottom: 0px !important"><strong> Nous utilisons des cookies :</strong> Ce site web utilise des cookies afin de vous fournir une meilleure experience de navigation. <a id="accept-cookies-button" style="border:0px;display:inline-block;padding:2px 4px;background:#FFFFFF30;border-radius:0.3em; color:#FFFFFF; cursor:pointer; font-size:1em">Accepter<a> <a href="/pages/mentions-legales" style="border:0px; color:#FFFFFF; cursor:pointer; font-size:1em; text-decoration: underline;">En savoir plus</a></p>';
    container.appendChild(description);

   /*var accept = document.createElement('a');
    accept.style.cssText = 'border:0px;display:inline-block;padding:4px 4px;' +
      'background:#83be32;border-radius:0.3em;' +
      'color:#FFFFFF;cursor:pointer;font-size:1em;';
    accept.innerHTML = 'Accepter';
    accept.addEventListener('click', function() {
      if ('bottom' === 'top') container.style.top = '-150px';
      else container.style.bottom = '-150px';

      // Set the cookies for the accepts
      document.cookie = '_accept_banner=accept';
      document.cookie = '_accept_banner_ip=' + ip;

     // addLog('accept', ip);
    });
    container.appendChild(accept);

    /*var decline = document.createElement('a');
    decline.style.cssText = 'border:0px;display:inline-block;padding:8px 20px;' +
      'background:#f73232;border-radius:0.3em;' +
      'color:#FFFFFF;cursor:pointer;margin-left:10px;' +
      'font-size:1em;';
    decline.innerHTML = 'Refuser';
    decline.addEventListener('click', function() {
      if ('bottom' === 'top') container.style.top = '-150px';
      else container.style.bottom = '-150px';

      // Set the cookies for the accepts
      document.cookie = '_accept_banner=decline';
      document.cookie = '_accept_banner_ip=' + ip;

	//addLog('decline', ip);
    });
    container.appendChild(decline);*/
/*
    if (true) {
      var info = document.createElement('a');
      info.style.cssText = 'border:0px;display:inline-block;padding:4px 10px;' +
        'background:#413fb5;border-radius:0.3em;' +
        'color:#FFFFFF;cursor:pointer;margin-left:10px;font-size:1em;';
      info.innerHTML = '&#9432';
      info.setAttribute('href', 'https://monexpresso.myshopify.com/pages/mentions-legales');
      info.setAttribute('target', '_blank');
      container.appendChild(info);
    }
*/
    // Append the notification to the body
    document.body.appendChild(container);
    document.getElementById("accept-cookies-button").addEventListener('click', function(){
      if ('bottom' === 'top') container.style.top = '-150px';
      else container.style.bottom = '-150px';

      // Set the cookies for the accepts
      var d = new Date();
      var the_year = d.getFullYear + 1;
      d.setFullYear(the_year);
      var expires = "expires="+ d.toUTCString();
      document.cookie = "_accept_banner=accept; path=/;" + expires;
      document.cookie = 'path=/; _accept_banner_ip=' + ip;

     // addLog('accept', ip);
    });
    if ('bottom' === 'top') {
      container.style.top = '-150px';
      setTimeout(function() { container.style.top = '0px'; }, 10);
    } else {
      container.style.bottom = '-150px';
      setTimeout(function() { container.style.bottom = '0px'; }, 10);
    }
  }

  function isInEurope(intel) {
    return europe.indexOf(intel.country_code) > -1;
  }

  getIntel()
    .then(function(intel) {
      // Check if the notification should be shown (europe)
      if (true) {
        // Check whether the country is in europe
        var result = isInEurope(intel)
        if (!result) return { showBanner: false, ip: intel.ip };
        return checkCookie(intel.ip);
      }

      // Check whether the ip has already been registered
      return checkCookie(intel.ip);
    })
    .then(function(data) {
      // If the user has already accepted or declined don't add the notification
      if (!data.showBanner) return;

      // Add the notification
      addNotification(data.ip);
    })
    .catch(function(e) {
      console.error('An error has occurred when adding the cookie notification', e);
    });
})();